module.exports = __webpack_public_path__ + "static/2-problem-solve-ddd470d0de799abd5ef7c8e67e2ed6a5.mp4";